import { render, staticRenderFns } from "./impactVentureInformation.vue?vue&type=template&id=de822e6c"
import script from "./impactVentureInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./impactVentureInformation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxCardImpactResultSkeleton: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/ImpactResultSkeleton.vue').default,IxCardImpactStrategyResults: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/ImpactStrategyResults.vue').default,IxCardImpactCarryResults: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/ImpactCarryResults.vue').default,IxCardGhgResults: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/GhgResults.vue').default,IxCardCustomImpactResults: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/CustomImpactResults.vue').default,IxSectionText: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/SectionText.vue').default,IxSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/Section.vue').default})
